export {
  getMajorReactVersion,
  isReactVersionAtLeast,
  isReactVersionAtLeast16,
  isReactVersionAtLeast17,
  isReactVersionAtLeast18,
  isReactVersionAtLeast19,
  reactVersion,
  reactVersionMajor,
} from './reactVersion';
